import React from "react";
import { BaseVerticalNavigation } from "./BaseVerticalNavigation";

interface VerticalNavigationProps {
  ariaLabel?: string;
  className?: string;
  collapse: boolean;
  children?: React.ReactNode;
}
const VerticalNavigation: React.FC<VerticalNavigationProps> = (
  props: VerticalNavigationProps
) => {
  return (
    <BaseVerticalNavigation {...props}>{props.children}</BaseVerticalNavigation>
  );
};

export default VerticalNavigation;
